import SectionDashboard from "../../../../components/Section/SectionDashboard";
import PageProtected from "../../../../components/Page/PageProtected";
import SectionArchive from "./SectionArchive";
import { useTheme } from "@mui/material";
import SectionDisclaimer from "../../../../components/Disclaimer/SectionDisclaimer";

export default function ArchiveWelcome() {
   
const theme = useTheme();

return (
<>
<PageProtected
    
    headline="GENETICS - "
    specify="SECURE GENOME ARCHIVE"
    
    main = {<>

    {theme.palette.mode === "light" ? (
    
     <SectionDashboard
    
                colorContainer="transparent"
    
                colorSection_1="grey.C500"
                Section_1={ <SectionArchive /> }
    
                colorSection_2="grey.C100"
                Section_2={ <SectionDisclaimer />}
                
                colorSection_3="grey.C100"
                Section_3= { "" } 
    
                colorSection_4="primary.C200"
                Section_4={""}
    
            />
        
    ):(

 <SectionDashboard

            colorContainer="transparent"

            colorSection_1="greydark.C500"
            Section_1={ <SectionArchive /> }

            colorSection_2="greydark.C800"
            Section_2={<SectionDisclaimer /> }
            
            colorSection_3="grey.C100"
            Section_3= { "" } 

            colorSection_4="primary.C200"
            Section_4={""}
        />

    )}


    </>}
    />

</>

)}